import { i18n } from '@/i18n/i18n.config'
import { sortedCategories } from '@/constants/categories'
import type { NavigationMenuItem } from '@nuxt/ui'

const { t } = i18n.global

export const vehicleDomainLinks: NavigationMenuItem[] = sortedCategories.map(
  (category) => ({
    label: category.title,
    value: category.slug,
    to: `/offers?category=${category.slug}`,
    target: '_self',
    exactQuery: 'partial',
  })
)

export const companyDomainLinks: NavigationMenuItem[] = [
  {
    label: t('about'),
    to: '/ueber-uns',
    target: '_self',
  },
  {
    label: t('contact'),
    to: '/kontakt',
    target: '_self',
  },
  {
    label: t('blog'),
    to: '/blog',
    target: '_self',
  },
  {
    label: t('career'),
    to: 'https://www.linkedin.com/jobs/search/?currentJobId=4279594744&f_C=79605270&geoId=92000000&origin=COMPANY_PAGE_JOBS_CLUSTER_EXPANSION&originToLandingJobPostings=4279594744%2C4264547437',
    target: '_blank',
  },
]

export const legalDomainLinks: NavigationMenuItem[] = [
  { label: t('theFooter.imprint'), to: '/impressum' },
  { label: t('theFooter.privacy'), to: '/datenschutz' },
  {
    label: t('theFooter.termsLessor'),
    to: '/AGB/vermieter',
  },
  {
    label: t('theFooter.termsTenant'),
    to: '/AGB/mieter',
  },
]

export const socialDomainLinks: NavigationMenuItem[] = [
  {
    label: 'Instagram',
    to: 'https://www.instagram.com/colonia.tech/?hl=de',
    icon: 'i-custom-instagram',
  },
  {
    label: 'Facebook',
    to: 'https://www.facebook.com/p/Colonia-Tech-100088251050247/?locale=de_DE',
    icon: 'i-custom-facebook',
  },
  {
    label: 'LinkedIn',
    to: 'https://de.linkedin.com/company/colonia-technologies?trk=public_post_follow-view-profile',
    icon: 'i-custom-linkedin',
  },
  {
    label: 'YouTube',
    to: 'https://www.youtube.com/@colonia_technologies',
    icon: 'i-custom-youtube',
  },
  {
    label: 'TikTok',
    to: 'https://www.tiktok.com/@colonia.tech',
    icon: 'i-custom-tiktok',
  },
  {
    label: 'WhatsApp',
    to: 'https://api.whatsapp.com/send/?phone=4922182829729&text&type=phone_number&app_absent=0', // TODO: replace link
    icon: 'i-custom-whatsapp',
  },
].map((i) => ({ ...i, target: '_blank' }))
